<template>
  <div v-loading="loading">
    <el-table
        :data="tableData"
        :header-cell-style="{background:'#f2f2f2',color:'#222'}"
        border
        :max-height="1200"
        style="width: 100%">
      <el-table-column
          align="center"
          type="index"
          width="50"
          label="序号">
      </el-table-column>
      <el-table-column
          align="center"
          prop="areaName"
          :column-key="'areaName'"
          :filters="areaSelect"
          :filter-method="filterHandler"
          label="区域">
      </el-table-column>
      <el-table-column
          align="center"
          prop="province"
          :column-key="'provinceName'"
          :filters="provinceSelect"
          :filter-method="filterHandler"
          label="省份">
      </el-table-column>
      <el-table-column
          align="center"
          prop="city"
          :column-key="'cityName'"
          :filters="citySelect"
          :filter-method="filterHandler"
          label="城市">
      </el-table-column>
      <el-table-column
          align="center"
          prop="company"
          width="250px"
          label="企业名称">
      </el-table-column>
      <el-table-column
          align="center"
          prop="conpanyNature"
          :column-key="'company'"
          :filters="companySelect"
          :filter-method="filterHandler"
          label="企业性质">
      </el-table-column>
      <el-table-column
          align="center"
          prop="sumCapacity"
          label="产能(万吨/年)">
      </el-table-column>
      <el-table-column
          align="center"
          prop="cokeTye"
          label="焦炉炉型"
          width="150px">
          <!-- <template slot-scope="scope">
            <p>{{setLabel(scope.row.cokeTye)}}</p>
        </template> -->
      </el-table-column>
      <el-table-column label="炼焦装备(碳化室高度*孔数*组数)" align="center">
        <template slot-scope="scope">
          <span>{{ scope.row.cokeOvenEquip }}</span>
        </template>
      </el-table-column>
      <el-table-column
          align="center"
          prop="cokeOvenProcess"
          :column-key="'cokeOvenProcess'"
          :filters="cokeSelect"
          :filter-method="filterHandler"
          label="焦炉工艺">
      </el-table-column>
      <el-table-column
          align="center"
          prop="cokeQuenchingProcess"
          :column-key="'cokeQuenchingProcess'"
          :filters="quenchSelect"
          :filter-method="filterHandler"
          label="熄焦工艺">
      </el-table-column>
      <el-table-column
          align="center"
          prop="steelCokeUnion"
          :filters="yesSelect"
          :filter-method="filterHandler"
          label="是否钢焦联合">
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
import {companyCokeList,} from '@/api/coke'
import {baseArea, type} from '@/api'
import {tableSelectFilter} from '@/utils/api'
export default {
  name: "enterpriseCapacityDetailTabsOne",
  data() {
    return {
      loading:false,
      tableData: [],
      params:{
        areaName:'',
        cityName:'',
        provinceName:'',
        cokeTye:'',
        conpanyNature:'',
      },
      areaSelect:[],
      citySelect:[],
      provinceSelect:[],
      companySelect:[],
      quenchSelect:[],
      cokeSelect:[],
      yesSelect:[{
            text:'是',
            value:'是'
        },{
            text:'否',
            value:'否'
        }],
    }
  },
  created() {
    this.getSelectList(this.params);
    this.getList(this.params)
    type("issue_company_type").then((res)=>{
        res.data.map((item) => {
        let obj = {
            text:'',
            value:''
        };
        obj['text'] = item.dictValue
        obj['value'] = item.dictValue
        this.companySelect.push(obj)
    })
    return  this.companySelect
    })
    type("issue_coke_process").then((res)=>{
      // this.cokeSelect = tableSelectFilter(res.data['dictValue'])
      res.data.map((item) => {
        let obj = {
            text:'',
            value:''
        };
        obj['text'] = item.dictValue
        obj['value'] = item.dictValue
        this.cokeSelect.push(obj)
    })
    return  this.cokeSelect
    })
    type("issue_quench_process").then((res)=>{
      // console.log(this.quenchSelect)
      res.data.map((item) => {
        let obj = {
            text:'',
            value:''
        };
        obj['text'] = item.dictValue
        obj['value'] = item.dictValue
        this.quenchSelect.push(obj)
    })
    return  this.quenchSelect
    })
  },
  methods:{
    getList(params) {
      this.loading = true
      companyCokeList(params).then(res => {
        this.loading = false
        this.tableData = res.data;
      })
    },
    getSelectList(params) {
      baseArea(params).then(res => {
        this.areaSelect = tableSelectFilter(res.data['areaList'])
        this.citySelect = tableSelectFilter(res.data['cityList'])
        this.provinceSelect = tableSelectFilter(res.data['provinceList'])
      })
    },
    // tableChange(val) {
    //   // console.log(val)
    //   // let name =Object.keys(val)[0]
    //   // let tempList = val[name];
    //   // this.params[name] = tempList.length>0 ? tempList.join(','):'';
    //   // this.getSelectList(this.params)
    //   // console.log(Object.keys(val)[0])
    //   // console.log(tempList)
    // },
    filterHandler(value, row, column) {
      const property = column['property'];
      return row[property] === value;
    },

  }
}
</script>

<style scoped>

</style>
